export default {
    login1: 'Sie haben bereits ein Konto? ',
    login2: 'Zum Login gehen',
    login3: 'Passwort zurücksetzen?',
    login4: 'Starten Sie die Nutzung von 51shopy',
    login5: 'Passwort vergessen?',
    login6: 'Jetzt registrieren',
    login7: 'E-Mail',
    login8: 'Verifizierungscode',
    login9: 'Bestätigungscode eingeben',
    login10: 'Passwort',
    login11: 'Passwort bestätigen',
    login12: 'Bitte geben Sie Ihr Passwort erneut ein',
    login13: 'Registrieren',
    login14: 'Nächster Schritt',
    login15: 'Senden',
    login16: 'Bestätigungscode senden',
    login17: 'Bitte geben Sie die richtige E-Mail-Adresse und den Bestätigungscode ein! ',
    login18: 'Die Passwörter, die Sie zweimal eingegeben haben, stimmen nicht überein!',
    login19: "Verifizierungscode wurde gesendet",
    login20: "E-Mail-Adresse darf nicht leer sein",
    login21: 'Das E-Mail-Format ist falsch',
    login22: 'Der Bestätigungscode darf nicht leer sein',
    login23: 'Die Länge des Bestätigungscodes beträgt 4 Zeichen',
    login24: 'Das Passwort darf nicht leer sein',
    login25: 'Die Passwortlänge darf nicht weniger als 6 Zeichen betragen',
    login26: 'Passwort erfolgreich geändert! ',
    login27: 'Registrierung erfolgreich!',
    login28: 'Anmeldung erfolgreich',
    login29: 'Der Kontoname darf nicht leer sein',
    login30: 'Melden Sie sich unten bei Ihrem Konto an, um zu beginnen',
    login31: 'Konto',
    login32: 'Klicken Sie hier, um sich anzumelden',
    login33: "Kaufen Sie Qualitätsprodukte und freuen Sie sich über Prämien",
    login34: "Registrieren Sie sich und freuen Sie sich über ein wunderbares Geschenk",
    login35: "Anmelden",
    login36: "Registrieren",
    home1: 'Beliebt',
    home2: "Möchten Sie sich wirklich abmelden?",
    home3: 'Eingabeaufforderung',
    home4: 'OK',
    home5: 'Abbrechen',
    home6: 'Fans',
    home7: 'Folgen',
    home8: "Persönliches Zentrum",
    home9: "Ich habe es gekauft",
    home10: "Ich habe es verkauft",
    home11: 'Meine Brieftasche',
    home12: 'Beenden',
    home13: 'Gesamt',
    home14: 'Artikel',
    home15: 'Siedlung',
    home16: "Erschwinglicher Preis",
    home17: "Schnelle Logistik",
    home18: "Qualitätssicherung",
    home19: 'Über uns',
    home20: 'Hilfe-Center',
    home21: "Kundendienst",
    home22: "Lieferung und Abnahme",
    home23: "Unternehmenskooperation",
    home24: 'Suchempfehlungen',
    home25: "Freundliche Links",
    home26: 'Folgen',
    home27: 'Bereits besorgt',
    home28: 'Jetzt kaufen',
    home29: 'In den Warenkorb',
    home30: "Abholung erfolgreich!",
    home31: "Abholung erfolgreich abgebrochen!",
    home32: "Möchten Sie dem Benutzer wirklich nicht mehr folgen?",
    home33: "Erfolgreich abgebrochen!",
    home34: "Folge dem Erfolg!",
    home35: "Inhalt darf nicht leer sein",
    home36: 'Kommentar erfolgreich!',
    home37: 'Produktbewertungen',
    home38: 'Jetzt bewerten',
    home39: 'Bewertung',
    home40: 'Verlauf',
    home41: "Erfolgreich entfolgen!",
    home42: "Dieser Typ ist sehr geheimnisvoll und hat keine Biografie.",
    home43: 'Startseite',
    number1: "Mein Konto",
    number2: "Persönliches Zentrum",
    number3: "Geldbörse",
    number4: "Meine Favoriten",
    number5: "Beobachtungen",
    number6: "Meine Fans",
    number7: "Verlauf durchsuchen",
    number8: "Transaktionsmanagement",
    number9: "Ich habe gepostet",
    number10: "Ich habe gekauft",
    number11: "Ich habe es verkauft",
    number12: 'Einkaufswagen',
    number13: "Persönliche Homepage",
    number14: "Kundenservice",
    number15: 'Einstellungen',
    number16: 'Neue Adresse hinzufügen',
    number17: 'Adresse ändern',
    number18: 'Es können nur Bilddateien hochgeladen werden!',
    number19: 'Die Dateigröße darf 10 MB nicht überschreiten!',
    number20: "Bild erfolgreich hochgeladen",
    number21: "Balance",
    number22: 'Gegenstände sammeln',
    number23: "Persönliche Informationen",
    number24: 'Bearbeiten',
    number25: 'Senden',
    number26: 'Spitzname',
    number27: "Persönliches Profil",
    number28: 'Lieferadresse',
    number29: 'Hinzufügen',
    number30: 'Std.',
    number31: 'Nicht bezahlt',
    number32: "Warten auf Lieferung",
    number33: "Abgeschlossen",
    number34: 'Abgebrochen',
    number35: "Überprüfung steht aus",
    number36: 'Bestanden',
    number37: 'Abgelehnt',
    number38: "Bestellung abgeschlossen",
    number39: "Bestellung erfolgreich bezahlt!",
    number40: "Bestellung erfolgreich storniert!",
    number41: "Auszahlung erfolgreich!",
    number42: "Aufladen",
    number43: "Zurückziehen",
    number44: "Verbrauchsverlauf",
    number45: 'Bestellnummer',
    number46: "Zahlungsname",
    number47: 'Alle',
    number48: 'Abfrage',
    number49: 'Bestellnummer',
    number50: "Zahlungsname",
    number51: "51 Münze",
    number52: 'Bestellstatus',
    number53: 'Zeitpunkt der Auftragserstellung',
    number54: "Aktualisierungszeit der Bestellung",
    number55: 'Operation',
    number56: 'Bezahlt',
    number57: 'Bestellung stornieren',
    number58: 'Details',
    number59: 'Nummer',
    number60: "versendet",
    number61: "ausstehend",
    number62: "Abhebungsdatensatz",
    number63: 'Benutzer-ID',
    number64: "Auszahlungsbetrag",
    number65: 'Status',
    number66: 'Erstellungszeit',
    number67: "Aus dem Wallet abheben",
    number68: "Zurückziehen",
    number69: "Wallet-Bestelldetails",
    number70: "Alle Bestellungen",
    number71: "Ausstehende Zahlung",
    number72: "Warten auf Lieferung",
    number73: "Abgeschlossen",
    number74: 'Abgesagt',
    number75: 'Bezahlt',
    number76: "Alle Sendungen",
    number77: "Logistikauftragsnummer",
    number78: "Versand erfolgreich!",
    number79: "Ich habe es verkauft",
    number80: 'Noch keine Bestelldaten',
    number81: 'Bestellnummer',
    number82: "Bestellzeit",
    number83: 'Besteller',
    number84: 'Zeit ändern',
    number85: 'Details',
    number86: "Gesamt",
    number87: 'versendet',
    number88: 'Details',
    number89: "Logistik-Auftragsnummereingeben",
    number90: "Logistikauftragsnummer",
    number91: 'Bitte geben Sie die Logistikauftragsnummerein',
    number92: 'Abbrechen erfolgreich!',
    number93: "Erfolg!",
    number94: "Bestellung verspätet erfolgreich geliefert!",
    number95: 'Ich habe gekauft',
    number96: "Jetzt bezahlen",
    number97: 'Empfang bestätigen',
    number98: "Verspätete Lieferung",
    number99: 'Bestellung stornieren',
    number100: 'Verkäufer-Benutzer',
    number101: "Meine Sammlung",
    number102: "Meine Fans",
    number103: "Mein Follow",
    number104: "Zahlungsname",
    number105: "51 Münze",
    number106: 'Bestellstatus',
    number107: 'Zahlungszeitpunkt',
    number108: "Bezahlt",
    number109: "Bestellung erfolgreich bezahlt!",
    number110: "Alle Produkte",
    number111: "Möchten Sie das Produkt wirklich löschen?",
    number112: "Erfolgreich gelöscht!",
    number113: "Erfolgreich abgebrochen!",
    number114: "Möchten Sie das Produkt wirklich ins Regal stellen?",
    number115: "Möchten Sie das Produkt wirklich entfernen?",
    number116: "Erfolg!",
    number117: "Auf dem Regal",
    number118: "von der Stange",
    number119: 'Löschen',
    number120: 'Details anzeigen',
    cart1: 'Produktinformationen',
    cart2: 'Einzelpreis',
    cart3: 'Menge',
    cart4: 'Zwischensumme',
    cart5: 'Operation',
    cart6: 'Einzelpreis',
    cart7: "Sind Sie sicher, dass Sie löschen möchten?",
    cart8: 'Bestätigen',
    cart9: 'Abbrechen',
    cart10: 'löschen',
    cart11: "Die Warenkorbliste ist leer",
    cart12: 'Artikel, Artikel gesamt',
    cart13: 'gesamt',
    cart14: 'Siedlung',
    cart15: 'Adresse hinzufügen',

    cart16: "Eines der Felder “Telegram“ und “watchApp“ muss ausgefüllt werden",
    cart17: "Konfiguration der Benutzerinformationen erfolgreich!",
    cart18: "Bitte Lieferadresse auswählen bzw. eingeben!",
    cart19: "Bestellung erfolgreich erstellt!",
    cart20: 'Lieferadresse',
    cart21: "Sie müssen vor dem Absenden der Bestellung eine Lieferadresse hinzufügen.",
    cart22: 'Empfänger',
    cart23: 'Kontaktinformationen',
    cart24: 'Lieferadresse',
    cart25: 'Adresse wechseln',
    cart26: 'Adresse hinzufügen',
    cart27: 'Produktinformationen',
    cart28: 'Einzelpreis',
    cart29: 'Menge',
    cart30: 'Tatsächliche Zahlung',
    cart31: 'Gesamtpreis',
    cart32: 'Betragsdetails',
    cart33: 'Gesamtbetrag zu zahlen',
    cart34: 'Abs.',
    cart35: 'Lieferadresse ändern',
    cart36: 'Abbrechen',
    cart37: 'OK',
    cart38: 'Benutzerinformationen',
    cart39: 'Senden',
    cart40: "Nachname darf nicht leer sein",
    cart41: "Name darf nicht leer sein",
    cart42: "Mobilfunknummer darf nicht leer sein",
    cart43: "Land darf nicht leer sein",
    cart44: "Provinz/Gemeinde/Bezirk darf nicht leer sein",
    cart45: 'Stadt darf nicht leer sein',
    cart46: "Detaillierte Adresse darf nicht leer sein",
    cart47: "Postleitzahl darf nicht leer sein",
    cart48: "Adresse erfolgreich geändert!",
    cart49: "Adresse erfolgreich hinzugefügt!",
    cart50: 'Nachname',
    cart51: 'Name',
    cart52: 'Land',
    cart53: 'Provinz/Gemeinde/Region',
    cart54: 'Stadt',
    cart55: 'Detaillierte Adresse',
    cart56: 'Postleitzahl',
    cart57: 'Telefonnummer',
    cart58: "Ist es Standard?",
    cart59: 'Startseite',
    cart60: 'Kundenservice',
    cart61: 'Veröffentlichen',
    cart62: 'Mein',
    cart63: 'Einkaufswagen',
    cart64: 'Lieferzeit',
    cart65: 'Zahlungszeitpunkt',
    cart66: 'Lieferinformationen',
    cart67: 'Tatsächliche Zahlung',
    cart68: 'Senden an',
    cart69: 'Produkte',
    cart70: "Sie können eine Rechnung beantragen",
    cart71: 'Bestellinformationen',
    cart72: 'Händler',
    cart73: "Übermittlung erfolgreich!",
    cart74: "Kopieren erfolgreich",
    cart75: "Kopieren fehlgeschlagen",
    cart76: 'Anteil',
    cart77: 'Kreditlimit',
    cart78: 'Übertragen',
    cart79: 'Aufladebetrag',
    cart80: 'Aufladen',
    cart81: 'Klassifizierung',
    setup1: "Persönliche Informationen",
    setup2: 'Meine Lieferadresse',
    setup3: 'Mein Profil',
    setup4: 'Konto und Sicherheit',
    setup5: 'Datenschutz',
    setup6: 'Allgemein',
    setup7: 'Hilfe und Feedback',
    setup8: 'Über uns',
    setup9: 'Abmelden',
    setup10: 'Stationsnachricht',
    setup11: 'Noch keine Daten',
    setup12: "Erfolgreich zum Warenkorb hinzugefügt!",
    setup13: "In den Warenkorb legen fehlgeschlagen!",

    setup14: 'Produktbearbeitung',
    setup15: 'Produktveröffentlichung',
    setup16: 'Produkt-Coverbild',
    setup17: 'Produktkategorie',
    setup18: 'Produktname',
    setup19: 'Produktpreis (CNY)',
    setup20: 'Produktbeschreibung',
    setup21: 'Produktbilder (Max. 10 Bilder)',
    setup22: 'Zurücksetzen',
    setup23: "Produkt erfolgreich erstellt!",
    setup24: "Nicht genügend Produktbestand!",
    setup25: 'Zahlungsmethode',
    setup26: '51coin',
    setup27: 'Übertragung',
    setup28: 'Produktlink oder Name/Artikellink',
    setup29: "Der Benutzer ist kein Verkäufer und kann keine Produkte veröffentlichen!",
    setup30: "Nicht-menschliche Operation erkannt!",
    setup31: 'Produktbestand',
    setup32: 'Ansichten',
    setup33: "Bestellung erfolgreich übermittelt!",
    setup34: 'Bestellung anzeigen',
    setup35: 'Produktbestand',
    setup36: "Produktkategorie darf nicht leer sein",
    setup37: "Produktname darf nicht leer sein",
    setup38: "Die Produktbeschreibung darf nicht leer sein",
    setup39: "Der Produktbestand darf nicht leer sein",
    setup40: "Produktpreis darf nicht leer sein",
    setup41: "Das Titelbild darf nicht leer sein",
    setup42: "Produktbild darf nicht leer sein",
    setup43: "Die Überweisung wurde durchgeführt und wartet auf Bestätigung",
    setup44: "Bitte wählen Sie die Übertragungsmethode!",
    setup45: 'Fertigstellungszeit',
    setup46: '51 Münze',
    setup47: 'Überweisung',
    setup48: 'Übertragungsmethode',
    setup49: "Produktdetails",
    setup50: "Käufer",
    setup51: "Die Versandkosten für das Produkt betragen",
    setup52: "Versand",
    setup53: "Verkaufsmenge",
    setup54: "Mindestabnahmemenge",
    setup55: "Neue Adresse hinzufügen",
    setup56: "Konto wurde empfangen",
    setup57: "Kontaktinformationen des Zahlungsempfängers",
    setup58: "Händlerkontaktinformationen",
    setup59: "Kontaktinformationen des Käufers",
    setup60: "Kopieren",
    setup61: "Beliebt",
    setup62: "Füllen Sie mindestens ein Feld aus",
    setup63: "Kontakt",
    setup64: "VK-Schätzung",
    setup65: "Abonnieren Sie uns",
    setup66: "Kooperation mit ausländischen Internet-Prominenten",
    setup67: "Zahlungs- und After-Sales-Probleme",
    setup68: "Benutzerdividenden",

    setup69: "Währungstyp",
    setup70: "Wechselkurs",
    setup71: "Bearbeitungsgebühr",
    setup72: "Tatsächlicher Eingang",
    setup73: "Mindestauszahlungsbetrag",
    setup74: "Währung",
    setup75: "Bearbeitungsgebühr",
    setup76: "Tatsächlicher Eingang",

    setup78: "Einladungscode",
    setup79: "Bitte geben Sie den Einladungscode ein",
    setup80: "Mobilfunkvorwahl darf nicht leer sein",
    setup81: "Vorwahl",
    setup82: "Abbruchzeit",
    setup83: "Auszahlungsdetails",
    setup84: "Dividendendetails",
    setup85: "Ist es abgelaufen?",
    setup86: "Ob verwendet werden soll",
    setup87: "Nicht abgelaufen",
    setup88: "Abgelaufen",
    setup89: "Nicht verwendet",
    setup90: "Bereits verwendet",
    setup91: "Teilweise verwendet",
    setup92: "Rabatt",
    setup93: "Verwendeter Rabatt",
    setup94: "Verbleibender Rabatt",
    setup95: "Ob verwendet werden soll",
    setup96: "Ist es abgelaufen?",
    setup97: "Ablaufzeit",
    setup98: "Rabattzeit",
    setup99: "Allianz teilen",
    setup100: "Zahlung stornieren",
    setup101: "Schnittstelle schließen",
    setup102: "USDT-Zahlung",
    setup103: "Bezahlter Betrag",
    setup104: "Bestelltransaktionsbetrag",
    setup105: "Netzwerk",
    setup106: "Sie zahlen für das Netzwerk",
    setup107: "Zahlung erfolgreich",
    setup108: "Wallet-Adresse des Zahlungsempfängers",
    setup109: "Bitte überprüfen Sie sorgfältig, ob der tatsächliche Zahlungsbetrag mit dem von Ihnen überwiesenen Betrag übereinstimmt. Bei Fehlern tragen Sie die Konsequenzen.",
    setup110: "Ablaufzeit",
    setup111: "Warte auf Zahlung",
    setup112: "Zahlung erfolgreich",
    setup113: "Bestellung abgelaufen",
    setup114: "Blockchain-Transaktionen prüfen",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "Über uns",
    setup131: "Lieferbezogen",
    setup132: "Andere",
    setup133: "Versandbedingungen",
    setup134: "Paketzustellungs-/Abholzeit",
    setup135: "Nutzungsbedingungen",
    setup136: "Zahlungsmethode",
    setup137: "Rückgabebedingungen",
    setup138: "Datenschutzrichtlinie",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Arbeitsstunden:",
    setup141: "Ansprechpartner:",
    setup142: "Firmen-E-Mail:",
    setup143: "Postleitzahl:",
    setup144: "Adresse: ",

    setup0140: "Montag bis Freitag (9:00-18:00)",
    setup0141: " Herr Liang",
    setup0143: "999077",
    setup0144: "Raum 341, 3. Stock, öffentliches Industriegebäude, 56 Hoi Yuen Road, Kwun Tong, Hongkong",

    setup145: "Internationale Paketversandvereinbarung",
    setup146: "Aufgrund der Besonderheiten des internationalen Transports müssen Sie die internationalen Pakettransportregeln einhalten. Bitte lesen Sie die folgenden Geschäftsbedingungen sorgfältig durch und akzeptieren Sie sie.",
    setup147: "Paketentschädigungsstandard:",
    setup148: "Wenn Ihre Produkte während des Transports aus Gründen, die außerhalb der Kontrolle von 51shopy liegen, verloren gehen, fehlen, beschädigt, verspätet oder vom Zoll zurückgehalten werden, haftet 51shopy nicht für eine Entschädigung. Wir übernehmen auch keine Haftung für indirekte, nicht realisierte Gewinnverluste. Weitere Informationen finden Sie unter 'Paketversicherung und Entschädigung'.",
    setup149: "51shopy ist in den folgenden Fällen nicht zur Entschädigung verpflichtet (für nicht versicherte Pakete):",
    setup150: "1. Für Postverluste, die durch höhere Gewalt wie Naturkatastrophen oder aus Zollgründen verursacht wurden, wird keine Entschädigung gewährt.",
    setup151: "2. Wenn die Sendungen gegen Verbote oder Beschränkungen verstoßen, werden sie von den zuständigen Behörden entschädigungslos beschlagnahmt oder gemäß den einschlägigen Gesetzen und Vorschriften behandelt;",
    setup152: "3. Wenn beim Versenden eines Pakets das Paket in gutem Zustand verpackt ist, keine Anzeichen einer Demontage aufweist und nicht an Gewicht verloren hat, aber die Innenteile fehlen oder beschädigt sind, wird keine Entschädigung gewährt.",
    setup153: "4. Wenn aus der Sendungsverfolgung hervorgeht, dass das Paket nicht normal zugestellt wurde und das Logistikunternehmen bestätigt, dass das Paket vom Zoll beschlagnahmt wurde, hat die Untersuchung des Logistikunternehmens Vorrang und es erfolgt keine Entschädigung.",
    setup154: "5. Bei Verlust der E-Mail oder bei Verlust des Inhalts durch Verschulden des Kunden oder der E-Mail selbst wird keine Entschädigung geleistet.",
    setup155: "6. Stellt der Kunde zwischen dem Datum der E-Mail-Zustellung und dem Ablauf der Anfragefrist keine Anfrage und meldet er keinen Anspruch, erfolgt keine Entschädigung.",
    setup156: "7. Wird internationale Post vom Zielland gemäß dessen innerstaatlichem Recht zurückgehalten, beschlagnahmt oder vernichtet, erfolgt keine Entschädigung.",
    setup157: "Verbotene Gegenstände",
    setup158: "Halten Sie sich an die Vorschriften unseres Landes zu verbotenen und eingeschränkten Gegenständen:",
    setup159: "1. Befolgen Sie die Bekanntmachung des staatlichen Postamts, des Ministeriums für öffentliche Sicherheit und des Ministeriums für Staatssicherheit zur Veröffentlichung der „Vorschriften zum Umgang mit verbotenen Gegenständen“.",
    setup160: "2. Halten Sie die Bestimmungen der Verordnung Nr. 43 der Allgemeinen Zollverwaltung (Liste der für den Import und Export verbotenen und eingeschränkten Artikel der Volksrepublik China) ein.",
    setup161: "Artikel, die nicht per Post versendet werden können",
    setup162: "1. Artikel, deren Umlauf und Transport gemäß nationaler Gesetze verboten ist.",
    setup163: "2. Explosive, entzündbare, ätzende, radioaktive oder giftige Gefahrgüter.",
    setup164: "3. Veröffentlichungen, Bücher, Materialien oder Artikel mit reaktionärem oder obszönem Inhalt.",
    setup165: "4. Verschiedene Währungen.",
    setup166: "5. Artikel, die die öffentliche Gesundheit verletzen.",
    setup167: "6. Verderbliche Waren.",
    setup168: "7. Lebende Tiere (ausgenommen Bienen, Seidenraupen und Blutegel, sofern die Verpackung die Sicherheit der Arbeiter gewährleistet).",
    setup169: "8. Unzureichende Verpackung kann eine Gefahr für die Arbeiter darstellen oder andere verpackte Gegenstände verunreinigen oder beschädigen.",
    setup170: "9. Andere Artikel, die nicht für den Postversand geeignet sind.",
    setup171: "Sendungen, deren Zustellung nach den Gepflogenheiten der Post verboten ist",
    setup172: "1. Artikel, deren Qualität oder Verpackung Postangestellten Schaden zufügen oder andere Pakete oder Postausrüstung verunreinigen/beschädigen könnte.",
    setup173: "2. Sendungen mit Metallsiegeln oder anderen scharfen Kanten, die die Postbearbeitung beeinträchtigen könnten.",
    setup174: "3. Verschiedene Arten von Schusswaffen, Munition, explosiven, brennbaren, ätzenden, radioaktiven Stoffen oder Behältern, starken Giften, Betäubungsmitteln, biochemischen Produkten und infektiösen Stoffen.",
    setup175: "4. Jegliche Veröffentlichungen, Propagandamaterialien oder Drucksachen, die die soziale Sicherheit und Stabilität gefährden oder obszöne Inhalte enthalten.",
    setup176: "5. Verschiedene Gegenstände, die die öffentliche Gesundheit gefährden können.",
    setup177: "6. Dokumente oder Artikel, die im Empfängerland nicht akzeptiert werden oder deren Verbreitung nicht gestattet ist.",
    setup178: "Verfügbare Zahlungsmethoden",
    setup179: "Die Website unterstützt mehrere Zahlungsmethoden, darunter Kredit-/Debitkarten, WeChat, Alipay usw. Wenn Sie häufige Zahlungen oder Treuhandabzüge vornehmen müssen, können Sie auch das Guthaben zur Zahlung verwenden.",
    setup180: "- Wenn eine Rückerstattung für eine Kredit-/Debitkartenbestellung erfolgt, wird diese auf das ursprüngliche Konto zurückerstattet; die Rückerstattung für die Guthabenaufladung wird ebenfalls auf das ursprüngliche Konto zurückerstattet",
    setup181: "- Wenn eine Rückerstattung für über WeChat, Alipay usw. getätigte Bestellzahlungen erfolgt, wird die Rückerstattung auf das ursprüngliche Konto zurückerstattet;",
    setup182: "- Wenn eine Rückerstattung für die Restzahlung erfolgt, wird diese auf das Kontoguthaben zurückerstattet;",
    setup183: "51shopy-Datenschutzrichtlinie für Benutzer",
    setup184: "Die Sicherheit Ihrer persönlichen Daten ist uns sehr wichtig, und wir schätzen Ihr Vertrauen. Unter keinen Umständen werden wir Ihre persönlichen Daten an Dritte verkaufen oder weitergeben. Wir schützen die Sicherheit und Vertraulichkeit aller persönlichen Daten, die Sie uns zur Verfügung stellen, und verwenden diese ausschließlich wie hier beschrieben. Bei Fragen, Anregungen oder Anmerkungen zu dieser Datenschutzrichtlinie können Sie uns jederzeit über den 51shopy Online-Kundenservice oder das offizielle 51shopy-Kundenkonto kontaktieren.",
    setup185: "Diese Richtlinie gilt nicht für Dienste, die Ihnen von anderen Drittanbietern bereitgestellt werden, noch gilt sie für Dienste, für die wir unabhängig Datenschutzrichtlinien festgelegt haben.",
    setup186: "Bitte lesen und verstehen Sie diese Richtlinie sorgfältig, bevor Sie die Dienste von 51shopy nutzen. Ihre Zustimmung zu dieser Datenschutzrichtlinie bedeutet, dass Sie die von dieser Anwendung bereitgestellten Funktionen und die zur Ausführung der Funktionen erforderlichen personenbezogenen Daten verstanden haben.",
    setup187: "Die Eigentums- und Betriebsrechte der entsprechenden registrierten Benutzerdienste liegen bei ",
    setup188: "1. Welche persönlichen Daten erheben wir?",
    setup189: "Sie können unsere Website nutzen oder besuchen, ohne persönliche Daten oder Transaktionsdaten preiszugeben. Um unseren Service in vollem Umfang nutzen zu können, müssen Sie sich jedoch registrieren. Wenn Sie uns Ihre Daten zur Verfügung stellen, stimmen Sie der Übertragung und Speicherung dieser Daten auf unseren Servern zu.",
    setup190: "51shopy erfasst personenbezogene Daten, die Sie bei der Nutzung der Website angeben, darunter Ihren Namen, Ihre Kontaktdaten, Ihre E-Mail-Adresse, Ihren 51shopy-Kontonamen und Ihr Passwort sowie weitere Informationen, die für die Kontoerstellung erforderlich sind. Zusätzlich zu den personenbezogenen Daten, die wir bei der Registrierung erfassen und verarbeiten, erfassen, speichern und verarbeiten wir auch die folgenden Informationen über unsere 51shopy-Nutzer:",
    setup191: "1) Kaufinformationen",
    setup192: "2) Dienstkontoinformationen",
    setup193: "3) Zahlungsinformationen (Zahlungszeitpunkt, Zahlungsbetrag, Zahlungskanal usw.)",
    setup194: "4) Informationen zum Suchverlauf (Suchinhalte, Link-Klickverhalten, Browserverlauf, Klickverlauf usw.)",
    setup195: "5) Cookies und andere Computerinformationen",
    setup196: "Wir arbeiten mit Microsoft Clarity und Microsoft Advertising zusammen, um Ihre Nutzung unserer Website mithilfe von Verhaltensmetriken, Heatmaps und Sitzungswiederholungen zu erfassen und so unsere Produkte und Dienste zu verbessern und zu vermarkten. Daten zur Website-Nutzung werden mithilfe von Erstanbieter- und Drittanbieter-Cookies sowie anderen Tracking-Technologien erfasst, um die Beliebtheit von Produkten und Diensten sowie Ihre Online-Aktivitäten zu ermitteln. Darüber hinaus nutzen wir diese Informationen zur Website-Optimierung, zu Betrugs- und Sicherheitszwecken und für Werbung. Weitere Informationen zur Erhebung und Verwendung Ihrer Daten durch Microsoft finden Sie unter",
    setup197: "Microsoft-Datenschutzbestimmungen",
    setup198: "2. Wie verwenden wir Ihre persönlichen Daten?",
    setup199: "Wir werden Ihre persönlichen Daten weder verkaufen noch weitergeben und sind bestrebt, Ihre Daten und Ihre Privatsphäre zu schützen. Wir verwenden Ihre Daten, um Ihnen bessere Dienste bereitzustellen, darunter:",
    setup200: "1) Kontaktieren Sie uns per E-Mail und stellen Ihnen eine Reihe unserer Dienste zur Verfügung, darunter Beratungsdienste, Bestellinformationsdienste, Paketinformationsdienste, Produkt-Kundendienst usw.",
    setup201: "2) Um Ihnen per E-Mail, interner Post usw. Plattformaktivitäten mitzuteilen, einschließlich der Bereitstellung von Gutscheinen, Versandrabatten und Sonderaktionen sowie der Bereitstellung von Möglichkeiten zur Nutzung von Diensten Dritter.",
    setup202: "3) Wenn Sie die Links unserer Partnerhändler auf 51shopy durchsuchen, werden Ihre 51shopy-Benutzer-ID, zugehöriges Betriebsverhalten und Informationen (Suchinhalt, Link-Klickverhalten, Browserverlauf, Klickverlauf usw.) an die Quelle des Betriebsverhaltens-Links übermittelt, damit wir und unsere Partnerhändler zusammenarbeiten können, um Ihnen qualitativ hochwertige und effiziente Dienste bereitzustellen. Sie können hier klicken, um die 51shopy-Partnerhändler (www.taobao.com, www.1688.com) anzuzeigen.",
    setup203: "Gemäß Gesetzen, Vorschriften und nationalen Standards benötigen Partner unter den folgenden Umständen weder Ihre Genehmigung noch Ihre Zustimmung, um Ihre personenbezogenen Daten zu verwenden, zu übertragen oder offenzulegen:",
    setup204: "1) Gemäß den zwingenden Anforderungen von Gesetzen, Verordnungen, Verwaltungs- und Justizorganen und anderen rechtlichen Verpflichtungen;",
    setup205: "2) Soweit gesetzlich und behördlich zulässig, ist es notwendig, das öffentliche Interesse und die Sicherheit von Eigentum zu wahren und Sie oder andere 51shopy-Benutzer, 51shopy, verbundene Unternehmen oder Partner von 51shopy vor Schäden zu schützen;",
    setup206: "3) Notwendig, um die Kernfunktionen unserer Produkte und/oder Dienstleistungen zu realisieren oder die von Ihnen benötigten Dienstleistungen bereitzustellen;",
    setup207: "4) Ihre von Ihnen offengelegten personenbezogenen Daten oder andere rechtmäßig offengelegte personenbezogene Daten (wie etwa personenbezogene Daten, die durch juristische Nachrichtenberichte, die Offenlegung behördlicher Informationen oder andere Kanäle rechtmäßig offengelegt wurden) in einem angemessenen Umfang verarbeiten;",
    setup208: "5) Streitigkeiten oder Kontroversen zwischen Ihnen und anderen entsprechend Ihren Bedürfnissen zu regeln;",
    setup209: "6) Einhaltung der mit Ihnen unterzeichneten relevanten Vereinbarungen (einschließlich elektronischer Online-Vereinbarungen und entsprechender Plattformregeln) oder anderer Rechtsdokumente;",
    setup210: "7) Die Nutzung erfolgt auf Grundlage sozialer öffentlicher Interessen und gesundheitlicher Notfälle sowie im Einklang mit Gesetzen und Vorschriften.",
    setup211: "Zu den oben genannten Zwecken haben Sie außerdem das Recht, diese Benachrichtigung jederzeit abzubestellen. Sie können sich auf der 51shopy-Website anmelden und dies in der benutzerdefinierten Funktion selbst festlegen.",
    setup212: "Bitte beachten Sie, dass wir Ihre personenbezogenen Daten nicht an Werbetreibende weitergeben, es sei denn, wir haben Ihre Zustimmung eingeholt. Wir werden ohne die Zustimmung, das Wissen und die Anwesenheit ihrer Erziehungsberechtigten keine personenbezogenen Daten von Kindern oder anderen nicht geschäftsfähigen Personen anfordern oder weitergeben.",
    setup213: "Hiermit bestätigen Sie, dass Sie anonymisierte personenbezogene Daten weitergeben und übertragen und sicherstellen, dass der Datenempfänger die Identität der betroffenen Person nicht wiederherstellen oder reidentifizieren kann. Dies stellt keine Weitergabe, Übertragung oder öffentliche Bekanntgabe personenbezogener Daten an die Außenwelt dar. Die Speicherung und Verarbeitung solcher Daten erfordert weder eine Benachrichtigung an Sie noch Ihre Zustimmung.",
    setup214: "Wir können autorisierte Partner mit der Verarbeitung Ihrer personenbezogenen Daten beauftragen, damit diese Ihnen bestimmte Dienste bereitstellen oder bestimmte Aufgaben in unserem Namen ausführen können. Wir werden die Verarbeitung Ihrer Daten nur zu den in dieser Richtlinie genannten legitimen, ordnungsgemäßen, notwendigen, spezifischen und eindeutigen Zwecken anvertrauen, und autorisierte Partner haben nur Zugriff auf die Informationen, die zur Erfüllung ihrer Aufgaben erforderlich sind. 51shopy gibt Ihre E-Mail-Adresse, Ihren Kontonamen und Ihr Passwort für die 51shopy-Website, Ihre Kontaktinformationen und andere private Informationen nicht an unsere Partner weiter.",
    setup215: "3. Wie lange speichern wir Ihre Daten?",
    setup216: "Sobald Sie ein 51shopy-Konto erfolgreich registriert haben, speichern wir Ihre persönlichen Daten dauerhaft. Wenn Sie Ihr Konto kündigen oder Ihre persönlichen Daten löschen möchten, wenden Sie sich bitte an den Online-Kundenservice.",
    setup217: "Gemäß der DSGVO sind Verantwortliche und Auftragsverarbeiter verpflichtet, sämtliche personenbezogenen Daten nach Beendigung der Dienstleistung oder Ablauf des Vertrags bzw. der Vereinbarung zurückzugeben oder zu löschen, sofern keine gesetzliche Verpflichtung zur Aufbewahrung der Daten besteht.",
    setup218: "4. Wie schützen wir Ihre persönlichen Daten?",
    setup219: "Wir ergreifen alle angemessenen und umsetzbaren Maßnahmen, um Ihre personenbezogenen Daten zu schützen. Wir ergreifen alle angemessenen und umsetzbaren Maßnahmen, um sicherzustellen, dass keine irrelevanten personenbezogenen Daten erfasst werden.",
    setup220: "5. Richtlinienaktualisierung",
    setup221: "Um Ihnen ein besseres Produkt- und Serviceerlebnis zu bieten, arbeiten wir ständig an der Verbesserung unserer Produkte, Dienstleistungen und Technologien. Wenn sich neue Dienstleistungen und Geschäftsprozesse ändern, aktualisieren wir möglicherweise unsere Datenschutzrichtlinie, um Sie über spezifische Änderungen zu informieren. Bitte besuchen Sie diese Seite regelmäßig und beachten Sie die jeweils aktuelle Richtlinie. Sobald die neueste Richtlinie veröffentlicht ist, ist sie für Sie verbindlich.",
    setup222: "6. Kontakt",
    setup223: "Wenn Sie Fragen zu dieser Datenschutzerklärung haben, wenden Sie sich bitte an: ",
    setup224: "Bitte lesen Sie die 51shopy-Nutzungsbedingungen sorgfältig durch, bevor Sie sich als Benutzer registrieren, und stellen Sie sicher, dass Sie diese Bedingungen vollständig verstehen. Bitte lesen Sie die 51shopy-Nutzungsbedingungen sorgfältig durch und entscheiden Sie, ob Sie sie akzeptieren oder nicht, insbesondere die Bestimmungen zum Haftungsausschluss bzw. zur Haftungsbeschränkung, zum geltenden Recht und zur Streitbeilegung. Ohne die Annahme dieser 51shopy-Nutzungsbedingungen sind Sie nicht berechtigt, sich zu registrieren, anzumelden oder die Dienste von 51shopy zu nutzen. Ihre Registrierung, Anmeldung und Nutzung gelten als Ihre Zustimmung zu den 51shopy-Nutzungsbedingungen und als Ihr Einverständnis, an diese gebunden zu sein.",
    setup225: "Die 51shopy-Nutzungsbedingungen regeln Ihre Rechte und Pflichten in Bezug auf die 51shopy-Dienste (nachfolgend „Dienste“). Die 51shopy-Nutzungsbedingungen können jederzeit von 51shopy aktualisiert werden. Die aktualisierten 51shopy-Nutzungsbedingungen ersetzen die ursprünglichen Bedingungen nach ihrer Veröffentlichung und Bekanntmachung ohne weitere Ankündigung. Die aktuelle Version der 51shopy-Nutzungsbedingungen finden Sie auf der 51shopy-Plattform. Wir empfehlen Ihnen, sich regelmäßig über die aktualisierten 51shopy-Nutzungsbedingungen zu informieren, um Missverständnisse und Streitigkeiten zu vermeiden. Sollten Sie nach der Änderung der 51shopy-Nutzungsbedingungen mit den geänderten Bedingungen nicht einverstanden sein, stellen Sie bitte die Nutzung der 51shopy-Dienste umgehend ein. Ihre fortgesetzte Nutzung der 51shopy-Dienste gilt als Zustimmung zu den geänderten 51shopy-Nutzungsbedingungen.",
    setup226: "1. Geltungsbereich dieser Servicebedingungen",
    setup227: "Die Eigentums- und Betriebsrechte an den jeweiligen registrierten Benutzerdiensten liegen bei . Die bereitgestellten Dienste müssen in Übereinstimmung mit den von ihr herausgegebenen Serviceregeln, Bedingungen und Betriebsspezifikationen implementiert werden. Dies bedeutet auch, dass die jeweiligen Benutzer eine Vereinbarung mit 51shopy getroffen und alle Servicebedingungen akzeptiert haben.",
    setup228: "2. Erfassung und Verwendung von Informationen",
    setup229: "Wenn Sie die Dienste von 51shopy nutzen, müssen wir möglicherweise die folgenden zwei Arten Ihrer persönlichen Daten erfassen und verwenden:",
    setup230: "1. Um Ihnen die grundlegenden Funktionen unserer Dienste zur Verfügung zu stellen, müssen Sie uns die Erhebung und Nutzung der dafür erforderlichen Daten gestatten. Wenn Sie die Bereitstellung der entsprechenden Daten verweigern, können Sie sich nicht registrieren, anmelden oder unsere Dienste normal nutzen.",
    setup231: "2. Um Ihnen zusätzliche Funktionen unserer Dienste zur Verfügung zu stellen, können Sie den von uns erhobenen und verwendeten Informationen zustimmen oder nicht zustimmen. Wenn Sie die Bereitstellung verweigern, können Sie die entsprechenden zusätzlichen Funktionen nicht nutzen und die von uns beabsichtigten funktionalen Effekte nicht erzielen. Ihre Nutzung unserer Grundfunktionen wird dadurch nicht beeinträchtigt.",
    setup232: "Wir schützen Ihr Informations- und Wahlrecht während der Installation und Nutzung gemäß den gesetzlichen Bestimmungen. Wenn Sie 51shopy-Dienste nutzen, benötigen Dienste, die Funktionen auf Ihrem Gerät beinhalten, Ihre vorherige Zustimmung. Nach Ihrer Bestätigung ist 51shopy berechtigt, notwendige Zusatzfunktionen wie die Erfassung des geografischen Standorts, das Lesen des Adressbuchs, die Nutzung der Kamera und die Aktivierung von Aufnahmediensten zu aktivieren.",
    setup233: "Die gesammelten und verwendeten Informationen umfassen unter anderem den Namen des Benutzers, seine Kontaktdaten und andere grundlegende Informationen. Der Benutzer erklärt sich damit einverstanden, dass die Verwendung dieser Informationen den Bestimmungen von Artikel 3 „Schutz der Benutzerinformationen“ unterliegt.",
    setup234: "3. Schutz der Benutzerinformationen",
    setup235: "Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, es sei denn:",
    setup236: "1. Weitergabe zur Erfüllung rechtlicher Verpflichtungen erforderlich;",
    setup237: "2. Weitergabe mit Ihrer Zustimmung;",
    setup238: "4. Rechte und Pflichten des Nutzers",
    setup239: "1. Sie haben das Recht, sich auf der 51shopy-Website anzumelden, um Ihre persönlichen Daten zu überprüfen, zu korrigieren und zu ergänzen.",
    setup240: "2. Sie haben das Recht, sich an den Online-Kundendienst zu wenden, um Ihr Konto zu kündigen. Nach der Kündigung Ihres Kontos werden wir die Bereitstellung unserer Dienste für Sie einstellen und Ihre personenbezogenen Daten gemäß den geltenden Gesetzen löschen oder anonymisieren.",
    setup241: "3. In bestimmten Geschäftsfunktionen können wir Entscheidungen ausschließlich auf der Grundlage nicht-menschlicher automatisierter Entscheidungsmechanismen, einschließlich Algorithmen, treffen. Sollten diese Entscheidungen Ihre gesetzlichen Rechte beeinträchtigen, können Sie uns über den Kundenservice kontaktieren.",
    setup242: "4. Alle Informationen, die Sie 51shopy zur Verfügung stellen, müssen wahr, genau und nicht irreführend sein.",
    setup243: "Sie verstehen und stimmen zu, dass Sie verpflichtet sind, die Authentizität und Gültigkeit der von Ihnen bereitgestellten Informationen zu wahren.",
    setup244: "5. Sie dürfen Ihr registriertes Konto oder die Dienste von 51shopy nicht verwenden, um Inhalte zu erstellen, hochzuladen, zu kopieren, zu veröffentlichen oder zu verbreiten, die den normalen Betrieb von 51shopy stören oder die legitimen Rechte und Interessen anderer Benutzer oder Dritter verletzen.",
    setup245: "6. Sie dürfen keinen Teil des 51shopy-Dienstes oder der über den 51shopy-Dienst verwendeten oder erhaltenen Inhalte kopieren, plagiieren, verkaufen, weiterverkaufen oder für andere kommerzielle Zwecke verwenden.",
    setup246: "7. Sie tragen die alleinige Verantwortung für die Echtheit, Rechtmäßigkeit, Richtigkeit und Gültigkeit aller über Ihr 51shopy-Konto oder die 51shopy-Dienste übermittelten Informationen. Jegliche rechtliche Haftung im Zusammenhang mit den von Ihnen übermittelten Informationen liegt bei Ihnen und steht in keinem Zusammenhang mit 51shopy. Sie sind verpflichtet, 51shopy oder Dritten entstehende Verluste zu ersetzen. 51shopy behält sich das Recht vor, betroffene Nutzer und Benutzer haftbar zu machen.",
    setup247: "8. Sie tragen die volle Verantwortung für die Folgen aller Aktionen, die über Ihr Konto durchgeführt werden (einschließlich, aber nicht beschränkt auf die Unterzeichnung verschiedener Online-Vereinbarungen, die Veröffentlichung von Informationen, den Kauf von Waren und Dienstleistungen sowie die Offenlegung von Informationen).",
    setup248: "5. Informationsspeicherung",
    setup249: "51shopy hat keine Obergrenze für die Menge der übertragenen Informationen. Wir haben angemessene und praktikable Sicherheitsmaßnahmen ergriffen, die den Branchenstandards entsprechen, um Ihre Daten zu schützen und zu verhindern, dass personenbezogene Daten unbefugt abgerufen, weitergegeben, verwendet, verändert, beschädigt oder verloren werden. Bitte schützen Sie Ihre personenbezogenen Daten sorgfältig und geben Sie sie nur bei Bedarf an Dritte weiter. Vertrauen Sie nicht auf andere Handelstools, um Informationsdiebstahl oder Online-Betrug zu vermeiden",
    setup250: "6. Haftungsausschluss",
    setup251: "1.51shopy wird sein Bestes tun, um die tatsächliche Situation in den bereitgestellten Produktinformationen wiederherzustellen. Aufgrund des Einflusses verschiedener Faktoren wie Umgebung, Aufnahmewinkel, Geräteunterschiede usw. während des Produktaufnahmeprozesses können wir jedoch nicht garantieren, dass das Produkt genau dem Original entspricht.",
    setup252: "2.51shopy kauft bestimmte Produkte über die vom Benutzer angegebene Plattform. Sollte die von Ihnen angegebene Plattform nicht vorrätig sein, sich der Preis ändern, die Lieferung sich verzögern, das tatsächliche Produkt nicht mit den Produktinformationen auf der Website übereinstimmen, das Produkt anormal sein oder andere Faktoren höherer Gewalt dazu führen, dass ein normaler Kauf nicht möglich ist, werden wir Sie rechtzeitig informieren. Daher übernimmt „51shopy“ keine Haftung für die Ihnen entstehenden Verluste.",
    setup253: "3. Wenn bei den von Ihnen bei 51shopy gekauften Produkten Probleme nach dem Verkauf auftreten (wie z. B. Nichtverfügbarkeit, Beschädigung, Defekte usw.), werden wir diese zeitnah für Sie beheben.",
    setup254: "4. 51shopy übernimmt keine Verantwortung für Verluste oder Folgen, die durch Ihre proaktive Offenlegung Ihres 51shopy-Kontos oder durch Angriffe, Betrug usw. durch Dritte entstehen. Sie sollten vom Verletzer auf dem Rechtsweg oder auf andere Weise Schadensersatz verlangen.",
    setup255: "7. Verbotenes Verhalten",
    setup256: "Sie dürfen die Dienste von 51shopy nicht für die folgenden Aktivitäten verwenden:",
    setup257: "(1) Verstoß gegen ein Gesetz, eine Satzung, eine Verordnung oder eine Regelung.",
    setup258: "(2) Es handelt sich um folgende Transaktionen:",
    setup259: "(a) Betäubungsmittel, Steroide, bestimmte kontrollierte Drogen oder andere Produkte, die die Sicherheit des Verbrauchers gefährden können;",
    setup260: "(b) Drogenutensilien;",
    setup261: "(c) Zigaretten;",
    setup262: "(d) nicht genehmigtes Cannabis oder andere psychoaktive Pflanzen;",
    setup263: "(e) Ernährung, Vitamine, Nahrungsergänzungsmittel, Kräuter und natürliche Gesundheitsprodukte auf Abonnementbasis;",
    setup264: "(f) jegliches Material, das andere zu illegalen Aktivitäten anstiftet, veranlasst, unterstützt oder anweist;",
    setup265: "(g) gestohlene Gegenstände, einschließlich digitaler und virtueller Gegenstände;",
    setup266: "(h) Materialien, die zu Hass, Gewalt, rassistischer oder anderer Form von Bigotterie aufrufen oder kriminelle Aktivitäten ausnutzen;",
    setup267: "(i) als obszön angesehen;",
    setup268: "(j) jegliches Material, das Urheberrechte, Markenrechte, Öffentlichkeitsrechte oder Datenschutzrechte oder sonstige Eigentumsrechte gemäß den Gesetzen einer Rechtsordnung verletzt oder verletzt;",
    setup269: "(k) bestimmte pornografische Materialien oder Dienste;",
    setup270: "(l) Munition, Waffen oder bestimmte Teile oder Zubehör von Waffen, oder",
    setup271: "(m) Bestimmte Waffen oder Messer, die durch geltendes Recht geregelt sind.",
    setup272: "(3) Bezieht sich auf die folgenden Transaktionen:",
    setup273: "(a) Offenlegung personenbezogener Daten Dritter unter Verletzung einschlägiger Gesetze;",
    setup274: "(b) Pyramidensysteme, Ponzi-Systeme, Matrixsysteme, andere Systeme zum schnellen Reichwerden oder bestimmte mehrstufige Downline-Systeme unterstützt;",
    setup275: "(c) Transaktionen im Zusammenhang mit dem Erwerb von Renten- oder Lotterieverträgen, Prepaid-Einlagenkaufsystemen, Offshore-Bankgeschäften oder Transaktionen zur Finanzierung oder Refinanzierung von Kreditkartenschulden;",
    setup276: "(d) Verkauf einer Sache, bevor der Verkäufer die Kontrolle oder den Besitz darüber erlangt hat;",
    setup277: "(e) Zahlungsabwickler, die Zahlungen im Auftrag von Händlern einziehen;",
    setup278: "(f) im Zusammenhang mit dem Verkauf von Reiseschecks oder Zahlungsanweisungen;",
    setup279: "(g) im Zusammenhang mit Geldwechsel- oder Scheckeinlösungsvorgängen;",
    setup280: "(h) bestimmte Kreditreparatur- oder Schuldenregulierungsdienste, Kreditkartentransaktionen oder Versicherungsaktivitäten beinhaltet, oder",
    setup281: "(i) beinhaltet die Leistung oder Entgegennahme von Zahlungen im Zusammenhang mit Bestechung oder Korruption.",
    setup282: "(4) Der Verkauf von Produkten oder Dienstleistungen ist im Zusammenhang mit der Feststellung staatlicher Stellen möglicher Betrugsversuche.",
    setup283: "Sie tragen die rechtliche Verantwortung für Ihre Nutzung der Dienste von 51shopy, einschließlich, aber nicht beschränkt auf die Entschädigung für Verluste der verletzten Partei, und nachdem 51shopy zunächst die rechtliche Verantwortung wie Verwaltungsstrafen oder Entschädigung für durch das Benutzerverhalten verursachte Verstöße trägt, sind Sie verpflichtet, 51shopy einen gleichwertigen Entschädigungsbetrag sowie weitere Verluste zu zahlen, die 51shopy dadurch entstehen.",
    setup284: "8. Schadensersatzhaftung",
    setup285: "1. Wenn Ihre Handlungen dazu führen, dass 51shopy und/oder seine verbundenen Unternehmen Verluste erleiden (einschließlich direkter wirtschaftlicher Verluste, Verlust von Geschäftswert und indirekter wirtschaftlicher Verluste wie Entschädigungen, Vergleiche, Anwaltskosten, Erhaltungsversicherung, Prozesskosten usw.), sind Sie verpflichtet, 51shopy und/oder seine verbundenen Unternehmen für alle Verluste zu entschädigen.",
    setup286: "2. Wenn Ihre Handlungen dazu führen, dass 51shopy und/oder seine verbundenen Unternehmen von einem Dritten (einschließlich, aber nicht beschränkt auf Verkäufer auf Taobao, 1688 und anderen Plattformen) verklagt werden, können 51shopy und/oder seine verbundenen Unternehmen alle Verluste von Ihnen zurückfordern, nachdem sie Verpflichtungen wie eine finanzielle Entschädigung gegenüber dem Dritten übernommen haben.",
    setup287: "9. Geltendes Recht und Gerichtsstand",
    setup288: "1. Dieser Servicevertrag und alle separaten Vereinbarungen, in deren Rahmen wir Ihnen Dienste bereitstellen, unterliegen den Gesetzen Hongkongs und werden in Übereinstimmung mit diesen ausgelegt.",
    setup289: "2. Streitigkeiten, die sich aus Ihrer Nutzung der 51shopy-Dienste ergeben, sowie Streitigkeiten im Zusammenhang mit den 51shopy-Diensten werden durch Verhandlungen zwischen Ihnen und 51shopy beigelegt. Scheitern die Verhandlungen, kann jede Partei Klage vor dem zuständigen Gericht am Ort der Vertragsunterzeichnung einreichen.",
    setup290: "Nachfolgend finden Sie den Zeitplan für den Lagerausgang (an das Lager des Logistikanbieters gesendet) bzw. die Abholung durch den Logistikanbieter. Er dient nur als Referenz (der tatsächliche Zeitplan unterliegt den Vereinbarungen jedes Logistikanbieters):",
    setup291: "Paketzustellungs-/Abholzeit:",
    setup292: "Wenn der Paketstatus im 51shopy-Lager „Verpackt“ ist, arrangieren das Lager und das Logistikunternehmen die Lieferung/Abholung innerhalb einer festgelegten Zeit (das Logistikunternehmen ist an Wochenenden und Feiertagen geschlossen und die Abholung wird verschoben).",
    setup293: "Route",
    setup294: "Sende-/Abholplan (Peking-Zeit)",
    setup295: "GD-EMS",
    setup296: "Abholung von Montag bis Sonntag",
    setup297: "GD-EUB",
    setup298: "Abholung von Montag bis Sonntag",
    setup299: "GD-E-EMS",
    setup300: "Abholung von Montag bis Sonntag",
    setup301: "EUB-T",
    setup302: "Abholung von Montag bis Sonntag",
    setup303: "DHL Express",
    setup304: "Abholung von Montag bis Samstag",
    setup305: "DHL Heavy Cargo Standard Express",
    setup306: "Abholung von Montag bis Samstag",
    setup307: "Europäische DHL-Sonderlinie",
    setup308: "Versand von Montag bis Sonntag (Lieferung im Lager des Logistikdienstleisters)",
    setup309: "Amerikanische Linie (Klein)",
    setup310: "Versand von Montag bis Sonntag (Lieferung im Lager des Logistikdienstleisters)",
    setup311: "Britische Linie (Klein)",
    setup312: "Versand von Montag bis Sonntag (Lieferung im Lager des Logistikdienstleisters)",
    setup313: "Korea EMS",
    setup314: "Täglicher Versand aus unserem Lager",
    setup315: "PDB-Postpaket",
    setup316: "Haibao",
    setup317: "Europäische Eisenbahnen",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Aramex Standleitung",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Britische Linie",
    setup334: "NH-EMS",
    setup335: "Europäische Duty-Free-Linie",
    setup336: "Amerikanische Linie",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy ist eine Plattform, die chinesische Produktkauf- und -weiterleitungsdienste anbietet und Benutzern Produktinformationssuche, Einkaufs- und Weiterleitungsdienste zur Verfügung stellt. Während dieser Zeit bietet 51shopy grundlegende Produktprüfungsdienste, Kommunikationsbestätigungen mit Händlern und Kundendienstleistungen an, um Ihre gesetzlichen Rechte und Interessen zu schützen und Ihr Einkaufserlebnis zu gewährleisten.",
    setup340: "Wenn Sie feststellen, dass die gekaufte Ware gefälscht oder minderwertig ist, wenden Sie sich bitte an unseren Kundenservice oder senden Sie eine E-Mail an",
    setup341: "1. Empfang und Prüfung: Wenn Sie nach der Qualitätsprüfung des Produkts und der Einlieferung in das 51shopy-Lager oder nach Erhalt des Pakets Qualitätsprobleme feststellen oder an der Echtheit des Produkts zweifeln, wenden Sie sich bitte so schnell wie möglich an den Kundendienst und legen Sie entsprechende Nachweise vor.",
    setup342: "2. Beschwerdematerialien: Legen Sie das Bestellformular, den Zahlungsbeleg, die Produktbeschreibung und Beweise für gefälschte oder minderwertige Produkte vor.",
    setup343: "3. Nach Erhalt Ihrer Beschwerdeunterlagen wird unser Kundendienstteam die Einzelheiten mit Ihnen klären und Sie bei der Kommunikation mit dem Verkäufer unterstützen, um das Problem zu lösen und für Ihre gesetzlichen Rechte zu kämpfen.",
    setup344: "Bitte beachten Sie, dass aufgrund der Echtheit des Produkts eine weitere professionelle Bewertung und rechtliche Schritte erforderlich sein können. Falls eine professionelle Bewertungsagentur erforderlich ist, tragen Sie die Bewertungsgebühr. Zum Schutz der Rechte und Interessen aller Parteien empfehlen wir Ihnen, beim Kauf offizielle Kanäle und seriöse Verkäufer zu wählen, um das Risiko des Erwerbs gefälschter Waren zu verringern.",
    setup345: "Was ist die 14-tägige Rückgabe-/Umtauschgarantie?",
    setup346: "Die fünftägige Rückgabe- und Umtauschgarantie ist ein spezieller Kundendienst (einschließlich des Service selbst und des technischen Supports), den Verkäufer auf Drittanbieterplattformen Verbrauchern anbieten. Innerhalb von 14 Tegen nach Erhalt der Ware (d. h. innerhalb von 14 Tagen nach Einlagerung der Ware) können Käufer die gekaufte Ware gemäß dieser Regel und den entsprechenden Regeln der Drittanbieterplattform zurückgeben oder umtauschen.",
    setup347: "Wie stelle ich fest, ob ein Produkt für die Rückgabe-/Umtauschgarantie in Frage kommt?",
    setup348: "Produkte sind entweder für den 14-tägigen kostenlosen Rückgabe- und Umtauschservice ‚berechtigt‘ oder ‚nicht berechtigt‘ für den 14-tägigen kostenlosen Rückgabe- und Umtauschservice",
    setup349: "Ist es verfügbar?",
    setup350: "Typ",
    setup351: "Zum Beispiel",
    setup352: "Nicht verfügbar",
    setup353: "Wird anhand der vom Händler bereitgestellten Informationen ermittelt. Wenn wir dies nicht bestätigen können, verhandeln wir mit dem Verkäufer über die Rückgabe/den Umtausch. Das endgültige Ergebnis unterliegt jedoch der Entscheidung des Verkäufers.",
    setup354: "Anpassung",
    setup355: "Kundenspezifische Designprodukte",
    setup356: "Rücksendungen und Umtausch werden ausdrücklich nicht unterstützt",
    setup357: "Fördern Sie fehlerhafte Produkte",
    setup358: "Produkte, deren Verpackung, Etiketten und Zubehör auf Wunsch des Benutzers entfernt wurden",
    setup359: "Kleidungsetikett ist abgerissen",
    setup360: "Zeitungen und Zeitschriften",
    setup361: "Abonnierte Bücher und Zeitschriften",
    setup362: "Gebrauchtwaren",
    setup363: "Produkte außerhalb des chinesischen Festlands",
    setup364: "Produkte aus Übersee sowie aus Hongkong und Macau gekauft",
    setup365: "Unterwäsche",
    setup366: "Unterwäsche, Socken, Leggings",
    setup367: "Produkte für Erwachsene",
    setup368: "Sonstige vom Verkäufer angegebene Angelegenheiten",
    setup369: "Verkäuferregeln einhalten",
    setup370: "Essen",
    setup371: "Kekse, Süßigkeiten usw.",
    setup372: "Bücher (≥15 Bücher)",
    setup373: "Nicht weniger als 15 Bücher",
    setup374: "Artikel, die geöffnet wurden und die 'besonderen Standards' für Rücksendeverpackungen erfüllen müssen.",
    setup375: "Informationen zu Dichtungsprodukten finden Sie in der beigefügten Tabelle",
    setup376: "Verfügbar",
    setup377: "Rückgabe-/Umtauschanfragen, die innerhalb von 14 Tagen nach Erhalt eingereicht werden, bearbeiten wir gemäß den Standardverfahren.",
    setup378: "Wenn das Produkt alle der folgenden Anforderungen erfüllt:",
    setup379: "1. Der Verkäufer bietet eine Rückgabegarantie an;",
    setup380: "2. In einem wiederverkaufsfähigen Zustand, wie vom Verkäufer gefordert;",
    setup381: "3. Die Speicherdauer beträgt maximal  14 Tege.",
    setup382: "Bei Produkten mit kostenlosem Versand tragen Sie die Versandkosten bei der Rücksendung des Produkts. Bei Produkten ohne kostenlosen Versand tragen Sie die Versandkosten, wenn der Verkäufer das Produkt an unser Lager sendet und wenn Sie das Produkt an den Verkäufer zurücksenden.",
    setup383: "So beantragen Sie den Rückgabe-/Umtauschservice",
    setup384: "Innerhalb von 14 Tagen nach der Änderung des Bestellstatus auf 'Lagerbestand' (gerechnet ab der nächsten Stunde nach der Statusänderung auf 'Lagerbestand',  14 Tege = 336 Stunden) können Sie auf der Seite einen Rückgabe- und Umtauschservice beantragen. Nach Ablauf der Frist werden Anträge möglicherweise nicht mehr angenommen.",
    setup385: "Vorsichtsmaßnahmen und FAQs",
    setup386: "Hinweise:",
    setup387: "Der Gesamtbetrag der Rückerstattung/des Umtauschs basiert auf dem tatsächlich von Ihnen bezahlten Produktpreis",
    setup388: "Wir können Produkte nur für Sie zurückgeben/umtauschen, wenn der Verkäufer damit einverstanden ist",
    setup389: "Nachdem Sie den Rückgabe-/Umtauschservice beantragt haben, stellen Sie bitte sicher, dass auf Ihrem Konto genügend Guthaben vorhanden ist, um die Rücksende- und Servicegebühr zu bezahlen.",
    setup390: "Die Anforderungen an die Rücksendeverpackung einiger Produkte entnehmen Sie bitte der folgenden Tabelle. Wenn die Anforderungen nicht erfüllt sind, können Sie das Produkt nicht zurückgeben/umtauschen.",
    setup391: "Spezielle Standards",
    setup392: "Produktkategorie",
    setup393: "Spezielle Standards",
    setup394: "Neue Sportschuhe",
    setup395: "Diebstahlsicherungen (sofern vorhanden) und Manipulationsschutzaufkleber wurden nicht durchgeschnitten/entfernt und sind voll funktionsfähig.",
    setup396: "Waschmittel / Tampon / Papier / Parfüm",
    setup397: "Versiegelte Einwegbehälter für Körperpflegeprodukte müssen, sofern vorhanden, versiegelt bleiben.",
    setup398: "Haarpflege/Perücken",
    setup399: "Versiegelte Einwegverpackungen für Haarpflegeprodukte (sofern vorhanden) müssen versiegelt bleiben.",
    setup400: "Hautpflege/Körperpflege/Ätherische Öle",
    setup401: "Die versiegelte Einwegverpackung des Produkts (sofern vorhanden) muss versiegelt bleiben",
    setup402: "Kosmetik/Parfüm/Beauty-Tools",
    setup403: "Digitale Produkte/Haushaltsgeräte (ausgenommen Kameras und Großgeräte)",
    setup404: "1. Die Internet-Zugriffslizenz ist nicht beschädigt (zerstört).",
    setup405: "2. Kein Wasserschaden.",
    setup406: "Digitalkamera/Spiegelreflexkamera/Kamera",
    setup407: "Der Auslöser einer Spiegelreflexkamera sollte nicht öfter als 20 Mal gedrückt werden.",
    setup408: "Großgeräte",
    setup409: "1. LCD-Fernseher, Klimaanlage: Noch nicht an der Wand installiert, einfaches Debuggen ist möglich.",
    setup410: "2. Waschmaschine: wurde noch nicht mit Wasser benutzt.",
    setup411: "Modelle / Anime-Peripheriegeräte / Anime-Peripheriegeräte / Rollenspielprodukte / Brettspiele",
    setup412: "Das Klebeband und die Plastiksiegel (sofern vorhanden) auf Modellen, Figuren, Soldatenmodellen, BJD und anderen Produkten können nicht entfernt werden.",
    setup413: "Elektronische Komponenten",
    setup414: "1. Schweißen ist verboten.",
    setup415: "2. Der integrierte Schaltkreis wurde noch nie auf einem IC-Sockel montiert.",
    setup416: "3. Einwegverpackungen mit Verbrauchsmaterialien wie Wärmeleitpaste, Elektronikkleber, Vergusskleber, Dichtmittel, Klebstoff, leitfähiger Kleber, leitfähiger Tinte usw. müssen versiegelt aufbewahrt werden.",
    setup417: "Unterkategorie „Spielesoftware“ unter der Kategorie der ersten Ebene „Videospiele/Zubehör/Spiele/Spieleanleitungen",
    setup418: "Tiernahrung, Gesundheitsprodukte und Medikamente unter der Kategorie der ersten Ebene „Haustiere/Tiernahrung und -bedarf",
    setup419: "Bücher/Zeitschriften",
    setup420: "1. Die versiegelte Einwegverpackung des Produkts (sofern vorhanden) muss versiegelt bleiben",
    setup421: "2. Das Produkt darf keine Knickspuren, Wasserflecken, Schmutz, Tinte oder Lesespuren aufweisen.",
    setup422: "Sekundäre Kategorie „Tiergesundheitsprodukte/Tierarzneimittel“ unter der primären Kategorie „Tierhaltung/Agrarprodukte“",
    setup423: "Versiegelte Einwegverpackungen (sofern vorhanden) für Produkte wie Lebensmittel (einschließlich Nahrungsergänzungsmittel), Kosmetika, medizinische Geräte, Verhütungsmittel, Körperpflegeprodukte, Produkte für Erwachsene, Babywindeln, Bücher und audiovisuelle Produkte müssen versiegelt bleiben.",
    setup424: "Mit ‚Versiegelung‘ ist das Siegel bzw. die Kunststoffverpackung gemeint, die der Hersteller auf der Produktverpackung verwendet.",
    setup425: "Häufig gestellte Fragen:",
    setup426: "1. Was soll ich tun, wenn bei einer Bestellung, die nicht von der 'Rückgabe- und Umtauschgarantie' abgedeckt ist, nach dem Verkauf Probleme auftreten?",
    setup427: "Bei Qualitätsproblemen mit dem Produkt prüft 51shopy die tatsächliche Situation mit dem Verkäufer, erarbeitet eine endgültige Lösung und benachrichtigt den Benutzer. Liegen keine Qualitätsprobleme vor, können gemäß den Regeln der Drittanbieterplattform keine Rückgabe- oder Umtauschdienste angeboten werden. 51shopy wird sein Bestes tun, um mit dem Verkäufer zu kommunizieren und die Rechte und Interessen der Benutzer zu schützen.",
    setup428: "2. Wer ist für den Versand verantwortlich, wenn ich die 'Rückgabe-/Umtauschgarantie' in Anspruch nehme?",
    setup429: "Bevor Sie den Rückgabe- und Umtauschservice beantragen, muss das Produkt neu sein und den Wiederverkaufsbedingungen entsprechen. Wenn das Produkt keine Qualitätsmängel aufweist, trägt der Benutzer die Versandkosten. Wenn das Produkt Qualitätsmängel aufweist, trägt der Verkäufer die Versandkosten, nachdem der Benutzer den Antrag eingereicht hat.",
    setup430: "3. Wenn der Bestellstatus nicht „Versendet“ lautet, fallen dann Kosten für die Rücksendung an?",
    setup431: "Keine Sorge, in diesem Fall fallen keine Kosten an. Ihnen entstehen nur dann Kosten, wenn die Rücksendeanforderung drei Bedingungen erfüllt: Erstens, das Produkt weist keine Qualitätsmängel auf. Zweitens, das Produkt ist bereits im Lager vorrätig. Drittens, Sie haben die Anzahl der kostenlosen Rücksendungen in diesem Monat ausgeschöpft. Daher berechnen wir Ihnen keine Kosten, wenn das Produkt noch nicht versandt wurde.",
    setup432: "E-Mail:",
    setup433: "Tel: +85251387262",
    setup434: "Adresse: Zimmer 341, 3. Stock, öffentliches Industriegebäude, 56 Hoi Yuen Road, Kwun Tong, Hongkong",
    setup435: "Unterstützt von 51shopy – Space Network Technology Co., Ltd.",
    setup436: "Wir unterstützen Sie bei der Verarbeitung",
    setup437: "Der heiße Ausverkauf von gestern",
    setup438: "Schneller Verkauf",
    setup439: "Verkauft",
    setup440: "Zahlung fehlgeschlagen",
    setup441: "Warte auf Portozahlung",
    setup442: "Porto bezahlt, warte auf Bestätigung der Bank",
    setup443: "Porto bezahlt",
    setup444: "Spezifikationen",
    setup445: "Tatsächliche Zahlung",
    setup446: "Es wird empfohlen, die Stornierung einer Bestellung sorgfältig zu überdenken. Die Plattform übernimmt keine Verantwortung für die Stornierung einer Bestellung!",
    setup447: "Wechseln",
    setup448: "Porto bezahlen",
    setup449: "Einkaufszentrum Bestellung",
    setup450: "Mehr",
    setup451: "Einkaufszentrum",
    setup452: "Einkauf",
    setup453: "Freigeben",
    setup454: "Verkaufen",
    setup455: "Verlauf",
    setup456: "Bestellung",
    setup457: "Gesamtbetrag",
    setup458: "Laden betreten",
    setup459: "Mehr anzeigen",
    setup460: "Zusammenbruch",
    setup461: "Eingabe",
    setup462: "Das Produkt ist ausverkauft.",
    setup463: "Wir empfehlen folgende ähnliche Produkte",
    setup464: "Ähnliche Produkte",
    setup465: "Haftungsausschluss",
    setup467: "Verpackung bezieht sich auf die Originalverpackung des Produkts. Bei einer Inspektion wird die Logistikverpackung mit Ausnahme des Produkts selbst entfernt. Um Schäden am Produkt zu vermeiden, werden die erforderlichen Schutzverpackungsmaterialien aufbewahrt. Wir übernehmen keine Verantwortung für die Entfernung der Verpackung.",
    setup468: "Inlandsgesamtfracht Bei Waren desselben Verkäufers wird die Frachtabweichung von uns angepasst.",
    setup469: "Wir erstellen für Sie von jedem Produkt 3-7 kostenlose Fotos. Sollten Sie zusätzliche Wünsche bezüglich exquisiter Fotodienstleistungen haben, erheben wir ggf. eine geringe Servicegebühr.",
    setup470: "Für kundenspezifische Produkte sind weder Rückgabe noch Umtausch möglich.",
    setup471: "Für Produkte, deren Rückgabe oder Umtausch vom Händler genehmigt wurde, können Sie innerhalb von 14 Tagen nach Änderung des Bestellstatus auf 'Auf Lager' eine Rückgabe oder einen Umtausch beantragen. Bei der Rückgabe oder dem Umtausch fallen für jede einzelne Produktrückgabe eine Bearbeitungsgebühr von ca. 0,75 US-Dollar sowie Inlandsversandkosten an. Der Gesamtbetrag beträgt ca. 3 US-Dollar.",
    setup472: "Alle",
    setup473: "Postleitweg",
    setup474: "Versand",
    setup475: "Die Längen-, Breiten- und Höhenangaben des Pakets werden benötigt",
    setup476: "Transportzeit",
    setup477: "Tag",
    setup478: "Steuerfrei",
    setup479: "Kann versichert werden",
    setup480: "VK-Schätzung",
    setup481: "Passwort-Registrierung abrufen",
    setup482: "Händler",
    setup483: "Bitte",
    setup484: "Bezahlen, sonst wird die Bestellung storniert",
    setup485: "Gesamtpreis der Ware",
    setup486: "Endbetrag",
    setup487: "Jetzt bezahlen",
    setup488: "Guthaben reicht nicht aus, bitte aufladen und bezahlen",
    setup489: "Keine passende Zahlungsmethode? Sie können zunächst versuchen, mit Ihrem Guthaben zu bezahlen",
    setup490: "Bereits auf Lager",
    setup491: "Fracht wurde angegeben",
    setup492: "Versandkosten bezahlt",
    setup493: "Lieferung nicht vorrätig",
    setup494: "Weiter bezahlen",
    setup495: "Internationale Logistik-Auftragsnummer",
    setup496: "Inlandslogistik-Auftragsnummer",
    setup497: "Ihr Browser unterstützt keinen HTML5-Videoplayer.",
    setup498: "Unterstützt nur das Hochladen von Bildern im PNG- und JPEG-Format!",
    setup499: "Abgeschlossen",
    setup500: "Zurück",
    setup501: "Sie haben keine Berechtigung, auf diese Seite zuzugreifen",
    setup502: "Transportberechnung",
    setup503: "Kooperieren Sie mit vielen Logistikunternehmen, um die günstigsten Rabatte zu erhalten",
    setup504: "VK-Schätzung",
    setup505: "Nach Produkten suchen",
    setup506: "Produkte basierend auf Suchkriterien anzeigen",
    setup507: "Grundlegende Informationen",
    setup508: "Bitte geben Sie den englischen Namen ein",
    setup509: "Bitte geben Sie den chinesischen Namen ein",
    setup510: "Hochgeladene Videos können nur im MP4-, WebM- oder OGG-Format vorliegen!",
    setup511: "Die Größe des hochgeladenen Videos darf 2 MB nicht überschreiten!",
    setup512: "Videodauer darf nicht überschreiten",
    setup513: "Sekunden",
    setup514: "Die Videodauer konnte nicht abgerufen werden. Bitte überprüfen Sie, ob die Videodatei beschädigt ist.",
    setup515: "Daten",
    setup516: "",
    setup517: "Bitte geben Sie die SKU ein",
    setup518: "Bitte geben Sie die Menge ein",
    setup519: "Bitte geben Sie den Preis ein",
    setup520: "Bitte geben Sie die englischen Produktdetails ein",
    setup521: "Bitte geben Sie die chinesischen Produktdetails ein",
    setup522: "Vereinfachtes Chinesisch",
    setup523: "Spanisch",
    setup524: "Portugiesisch",
    setup525: "Niederländisch",
    setup526: "Polnisch",
    setup527: "Deutsch",
    setup528: "Französisch",
    setup529: "Italienisch",
    setup530: "Mehrere Spezifikationen aktivieren",
    setup531: "Preis (CNY)",
    setup532: "Spec.Bilder+",
    setup533: "Spec.Wert+",
    setup534: "① Zum Ändern doppelklicken, zum Anpassen der Reihenfolge ziehen",
    setup535: "Spezifikationen hinzufügen",
    setup536: "Batch-Einstellungen",
    setup537: "Bitte auf der PC-Seite veröffentlichen",
    setup538: "Name",
    setup539: "Produktvideo hochladen",
    setup540: "Lagereingangszeit",
    setup541: "Lagerausgangszeit",
    setup543: "Meine Veröffentlichung",
    setup544: "Bitte authentifizieren Sie sich als Händler, bevor Sie das Produkt veröffentlichen",
    setup545: "Bitte gehen Sie zum PC-Ende, um das Produkt zu veröffentlichen",
    setup546: "Zielort",
    setup547: "Vereinigte Staaten von Amerika",
    setup548: "Gewicht (Gramm)",
    setup549: "Produktkategorie",
    setup550: "Bitte Kategorie auswählen",
    setup551: "Länge",
    setup552: "Breite",
    setup553: "Höhe",
    setup554: "Anfrage",
    setup555: "Vollkasko",
    setup556: "Versicherbar",
    setup557: "Zollfrei",
    setup558: "Versandkosten",
    setup559: "Paketlänge, -breite und -höhe erforderlich",
    setup560: "Transportzeit",
    setup561: "Tage",
    setup562: "USTD-Zahlung erfolgreich stornieren!",
    setup563: "Tageserinnerung: Bitte wählen Sie Ihr Zielland aus. Das System sucht dann nach verfügbaren Routen zu diesem Zielort",
    setup564: "Paketbeschränkungen",
    setup565: "Mindestgewichtsgrenze:",
    setup566: "Höchstgewichtsgrenze:",
    setup567: "Abrechnungsregeln für Volumengewicht:",
    setup568: "Größengrenze:",
    setup569: "Versand nicht möglich",
    setup570: "Versand möglich",
    setup571: "Gebührenstandards:",
    setup572: "Gewichtseinheit",
    setup573: "Einzelpreis",
    setup574: "Zollgebühr",
    setup575: "Treibstoffkosten",
    setup576: "Bearbeitungsgebühr",
    setup577: "Das Kreditlimit dieser Bank reicht nicht aus, daher können Sie diese Bank nicht auswählen!",
    setup578: "51coin-Guthaben reicht nicht aus, bitte aufladen!",
    setup579: "Bemerkung",
    setup580: "Bitte wählen Sie das Produkt aus, das Sie löschen möchten!",
    setup581: "Mit Google anmelden",
    setup582: "Das erste Bild ist standardmäßig das Hauptbild. Zum Ändern verschieben.",
    setup583: "Maximale Upload-Grenze erreicht",
    setup584: "Loggen Sie sich mit Telegram ein",
    setup585: "Logistik anzeigen",
    setup586: "Logistikinformationen",
    setup587: "Logistikauftragsnummer ändern",
    setup588: "E-Mail binden",
    setup589: "Bitte binden Sie zuerst Ihre E-Mail an",
    setup590: "Sie können bis zu 2 Spezifikationstypen eingeben!",
    setup591: "Gemeinsame Vorlagen",
    setup592: "Modell auswählen",
    setup593: "Abbrechen",
    setup594: "Hinzufügen",
    setup595: "Bitte wählen Sie den Spezifikationswert",
    setup596: "Nicht wiederholt hinzufügen",
    setup597: "Gemeinsame Vorlagen erfolgreich eingerichtet!",
    setup598: "SKU darf nicht leer sein",
    setup599: "Preis darf nicht leer sein",
    setup600: "Die Menge darf nicht leer sein",
    setup601: "Derselbe Spezifikationswert kann nicht hinzugefügt werden!",
    setup602: "① Zum Ändern doppelklicken",
    setup603: "Bitte geben Sie die Spezifikationsinformationen ein!",
    setup604: "Bitte geben Sie die Produktdetails sowohl in vereinfachtem Chinesisch als auch in Englisch ein!",
    setup605: "Änderung erfolgreich",
    setup606: "Spezifikationswert erfolgreich hinzugefügt!",
    setup607: "Als allgemein festlegen",
    setup608: "Füllen Sie mindestens einen Spezifikationswert ein!",
    setup609: "Bitte geben Sie vereinfachtes Chinesisch ein",
    setup610: "Bitte geben Sie Englisch ein",
    setup611: "Bitte geben Sie Spanisch ein",
    setup612: "Bitte geben Sie Portugiesisch ein",
    setup613: "Bitte geben Sie Niederländisch ein",
    setup614: "Bitte geben Sie Polnisch ein",
    setup615: "Bitte geben Sie Deutsch ein",
    setup616: "Bitte geben Sie Französisch ein",
    setup617: "Bitte geben Sie Italienisch ein",
    setup618: "Automatische Übersetzung",
    setup619: "Übersetzung",
    setup620: "Alle anderen",
    setup621: "VERSANDINFORMATIONEN",
    setup622: "Unser Ziel ist es, Ihnen die besten Versandoptionen anzubieten, egal wo Sie wohnen. Wir beliefern täglich Hunderte von Kunden weltweit und sind bestrebt, Ihnen erstklassigen Service zu bieten.",
    setup623: "A. Die Lieferzeit einer Bestellung ist in zwei Teile unterteilt:",
    setup624: "· Bearbeitungszeit: 3–7 Tage",
    setup625: "· Lieferzeit: 14–30 Tage",
    setup626: "B. Versandarten",
    setup627: "C. Versandkosten",
    setup628: "Geistiges Eigentum",
    setup629: "Land-/Seetransport",
    setup630: "Warte auf Empfang",
    setup631: "Union",
    setup632: "Teilen Sie Ihren Partnercode",
    setup633: "Die von Ihnen eingeladenen Freunde bestätigen, dass sie Ihren Allianzcode erhalten haben",
    setup634: "Erhalten Sie Ihre Affiliate-Provision",
    setup635: "Kopieren Sie diese URL und verwenden Sie sie, um Benutzer auf die Homepage Ihrer Partner-ID umzuleiten",
    setup636: "URL kopieren",
    setup637: "Meine Allianz",
    setup638: "Aufzeichnen",
    setup639: "Holen",
    setup640: "Häufig gestellte Fragen zum Eigenkapital",
    setup641: "Was ist das Partnerprogramm?",
    setup642:"51Shopy ist ein von allen Nutzern initiiertes Sharing- und Verdienstprojekt. Egal, ob Sie Privatperson oder Verkäufer sind: Werden Sie ein 51Shopy-Promoter, laden Sie neue Nutzer zur Registrierung bei 51Shopy ein und tätigen Sie erfolgreich Einkäufe. Der Nutzer wird Ihr exklusiver Nutzer und erhält für jede internationale Logistikleistung einen Rabatt in bar. Die Höhe des Rabatts kann bis zu einer Million Yuan betragen, nach oben hin ist keine Grenze festgelegt.",    
    setup643: "Wie wird mein Bonus berechnet?",
    setup644: "Sobald Sie Mitglied werden, wird Ihr Konto sofort mit einem Rabattsatz versehen. Je mehr internationale Logistikfrachtkunden Sie zur Registrierung einladen, desto mehr Boni erhalten Sie und desto höher ist Ihr Rabattsatz. Sobald der Bonus einen bestimmten Betrag erreicht, können Sie ihn in bar abheben oder zum Ausgleich von Servicegebühren der 51Shopy-Plattform verwenden. Der Rabattsatz beträgt.",
    setup645: "Wie kann ich kostenlos Werbung machen?",
    setup646: "Kopieren Sie Ihren Werbelink und senden Sie ihn an Ihre Freunde, indem Sie auf der Produktseite auf 'Teilen' klicken. Wenn diese die Seite besuchen und sich registrieren, werden sie zu Ihren persönlichen Benutzern.",
    setup647: 'Registrierungszeit',
    setup648: 'Transportkosten',
    setup649: 'Aktivierungsstatus',
    setup650: 'Bonus-Aufzeichnung',
    setup651: 'Anwendungszeit',
    setup652: 'Gesamtbelohnung',
    setup653: 'Benutzer einladen',
    setup654: 'Zur Brieftasche gehen',
    setup655: "Kreditkarte",
    setup656: "Laden Sie Freunde ein, um Provisionen zu genießen",
    setup657:"Verbundenes Mitglied",
    setup658: "Bestellung",
    setup659:"Die 51Shopy-Agentenplattform unterstützt Sie beim Online- und Offline-Kauf von Produkten in China. Geben Sie einfach den Produktlink ein und geben Sie die Bestellung auf. Unser Team bietet Ihnen von Anfang bis Ende erstklassigen Service.",
    setup660: "Lieferung an Lager",
    setup661:"Bei uns können Sie Produkte von verschiedenen Verkäufern kaufen und sie an das Lager von 51Shopy in China liefern lassen",
    setup662: "Qualitätsprüfung",
    setup663:"Sobald Ihre Artikel im Lager von 51Shopy eintreffen, führen wir eine gründliche Qualitätskontrolle durch, die alles von Mängeln über Größe bis hin zur Farbe abdeckt. Sie können sich darauf verlassen, dass 51Shopy einen zuverlässigen Kundendienst bietet.",
    setup664:"Weltweite Lieferung",
    setup665:"Im 51Shopy-Lager können Sie Produkte frei auswählen und kombinieren und den zuverlässigen Logistikservice von 51Shopy nutzen, um sie zu verpacken und zu Ihnen nach Hause zu liefern.",
    setup666: "Service aus einer Hand, sorgenfrei während des gesamten Prozesses",
    setup667:"Sobald sich die von Ihnen eingeladenen Benutzer registrieren, erhalten sie USD:",
    setup668: "Kostenloser Versand",
    setup669: "Ohne Porto",
    setup670: "Internationaler Versand ist nicht inbegriffen",
    setup671:"Logistikunternehmen",
    setup672: "Wählen Sie ein Logistikunternehmen aus",
    setup673: "Nachname des Absenders",
    setup674: "Letzte vier Ziffern",
    setup675: "Versendernummer",
    setup676:"Bitte eingeben",
    setup677: "Warten auf Speicher",
    setup678: "Ist der internationale Versand inbegriffen",
    setup679: "Ja",
    setup680: "Nein",
    setup681: "Klicken Sie auf die Schaltfläche 'Zum Home-Bildschirm hinzufügen'",
}
//德语